/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Position_Center_Right_TitleInputs */

const en_position_center_right_title = /** @type {(inputs: Position_Center_Right_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Position: Center Right`)
};

const fr_position_center_right_title = /** @type {(inputs: Position_Center_Right_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Position : Au Centre a Droite`)
};

const de_position_center_right_title = /** @type {(inputs: Position_Center_Right_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Position: Mitte rechts`)
};

const it_position_center_right_title = /** @type {(inputs: Position_Center_Right_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posizione: Centro destra`)
};

const ru_position_center_right_title = /** @type {(inputs: Position_Center_Right_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Позиция: Правый центральный полузащитник`)
};

const es_position_center_right_title = /** @type {(inputs: Position_Center_Right_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posición: Centro derecha`)
};

const zh_cn2_position_center_right_title = /** @type {(inputs: Position_Center_Right_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`位置：中右`)
};

const ja_position_center_right_title = /** @type {(inputs: Position_Center_Right_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ポジション: 中央右`)
};

const hi_position_center_right_title = /** @type {(inputs: Position_Center_Right_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्थिति: केंद्र दाएँ`)
};

const pt_pt2_position_center_right_title = /** @type {(inputs: Position_Center_Right_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posição: Centro-Direita`)
};

/**
* | output |
* | --- |
* | "Position: Center Right" |
*
* @param {Position_Center_Right_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const position_center_right_title = /** @type {((inputs?: Position_Center_Right_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Position_Center_Right_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_position_center_right_title(inputs)
	if (locale === "de") return de_position_center_right_title(inputs)
	if (locale === "it") return it_position_center_right_title(inputs)
	if (locale === "ru") return ru_position_center_right_title(inputs)
	if (locale === "es") return es_position_center_right_title(inputs)
	if (locale === "zh-CN") return zh_cn2_position_center_right_title(inputs)
	if (locale === "ja") return ja_position_center_right_title(inputs)
	if (locale === "hi") return hi_position_center_right_title(inputs)
	if (locale === "pt-PT") return pt_pt2_position_center_right_title(inputs)
	return en_position_center_right_title(inputs)
});